import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@material-ui/core';
import { useDetailStyles } from './styles';
import Instructions from '../instructions/Instructions';
import CardCode from './CardCode';
import SnackbarAlert from '../../../../../common/SnackbarAlert';

const Detail = ({ ...props }) => {
  const { row, instructions, index, mobile } = props;
  const classes = useDetailStyles();
  const [openAlert, setOpenAlert] = useState(false);

  const handleShare = (data) => {
    navigator.clipboard.writeText(JSON.stringify(data));
    setOpenAlert(true);
  };

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      justify="center"
      alignItems="center"
      className={classes.container}
    >
      <SnackbarAlert
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        severity="success"
        message="Copiado con éxito"
      />
      <Grid item xs={12}>
        <Typography className={classes.title}>¿Cómo usar?</Typography>
      </Grid>
      <Grid
        container
        item
        xs={12}
        spacing={4}
        direction={mobile ? 'column' : 'row'}
      >
        <Grid item xs={12} md={instructions.length === 0 ? 12 : 6}>
          <CardCode
            code={row.codeType === 'barcode' ? row.productFolio : row.code}
            password={row.password}
            barcode={index === 1}
            barcodeNumber={row.codeType === 'barcode' ? row.code : ''}
            onShare={handleShare}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Instructions instructions={instructions} />
        </Grid>
      </Grid>
    </Grid>
  );
};

Detail.propTypes = {
  row: PropTypes.object,
  instructions: PropTypes.array,
  index: PropTypes.number,
  mobile: PropTypes.bool,
};

export default Detail;
